module.exports = __webpack_public_path__ + "img/img-coins-right.b416b56.b416b563.png";